// extracted by mini-css-extract-plugin
export default {"wrapper-background":"JoinRoom_wrapper-background__y86nJ","items":"JoinRoom_items__eslkv","formSection":"JoinRoom_formSection__w4b6p"};